import { create } from "zustand";
import type { User, Session } from "@supabase/supabase-js";
import { supabase } from "../lib/supabaseClient";

interface AuthState {
  user: User | null;
  session: Session | null;
  loading: boolean;
  userId: string | null;
  initialize: () => () => void;
  signOut: () => Promise<void>;
  requestPasswordReset: (email: string, redirectTo?: string) => Promise<any>;
  verifyOtp: (email: string, token: string) => Promise<any>;
  updateUserPassword: (newPassword: string) => Promise<any>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  session: null,
  loading: true,
  userId: null,

  initialize: () => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      set({
        session,
        user: session?.user ?? null,
        userId: session?.user?.id ?? null,
        loading: false,
      });
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      set({
        session,
        user: session?.user ?? null,
        userId: session?.user?.id ?? null,
        loading: false,
      });
    });

    return () => subscription.unsubscribe();
  },

  signOut: async () => {
    await supabase.auth.signOut();
  },

  requestPasswordReset: async (email, redirectTo) => {
    return supabase.auth.resetPasswordForEmail(email, {
      redirectTo: redirectTo || window.location.origin + "/reset-password",
    });
  },

  verifyOtp: async (email, token) => {
    return supabase.auth.verifyOtp({ email, token, type: "recovery" });
  },

  updateUserPassword: async (newPassword) => {
    return supabase.auth.updateUser({ password: newPassword });
  },
}));
